/**
 * Shared production gate for global resilience handlers.
 * Overridable in tests because Jest typically runs with NODE_ENV=test.
 */

let installOverride: boolean | null = null;

export function setProductionHandlersInstallOverrideForTests(value: boolean | null): void {
  installOverride = value;
}

export function shouldInstallProductionHandlers(): boolean {
  if (installOverride != null) return installOverride;
  return process.env.NODE_ENV === "production";
}
